import { render, staticRenderFns } from "./Postback.vue?vue&type=template&id=083a3362&scoped=true"
import script from "./Postback.vue?vue&type=script&lang=js"
export * from "./Postback.vue?vue&type=script&lang=js"
import style0 from "./Postback.vue?vue&type=style&index=0&id=083a3362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083a3362",
  null
  
)

export default component.exports